import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import siteText from '../content/siteText.json';
import SectionCard from './SectionCard';

const About = () => {
    const { about } = siteText;

    const imageCardSx = {
        borderRadius: 5,
        overflow: 'hidden',
        border: '1px solid rgba(0, 71, 110, 0.10)',
        boxShadow: '0 12px 30px rgba(0, 71, 110, 0.06)',
        backgroundColor: '#fff7fb',
        minHeight: { xs: 280, md: 360 }
    };

    const splitRowSx = {
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 4,
        alignItems: 'stretch',
        mb: 4
    };

    return (
        <Container
            maxWidth={false}
            sx={{
                py: { xs: 4, md: 7 },
                width: 'min(92vw, 1600px)',
                mx: 'auto'
            }}
        >
            <Box sx={splitRowSx}>
                <Box
                    sx={{
                        width: { xs: '100%', md: '42%' },
                        flexShrink: 0
                    }}
                >
                    <Box sx={{ ...imageCardSx, height: '100%' }}>
                        <Box
                            component="img"
                            src="/img/outdoor_therapy_1.webp"
                            alt="Warm speech therapy session"
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: 'block'
                            }}
                        />
                    </Box>
                </Box>

                <Box
                    sx={{
                        width: { xs: '100%', md: '58%' },
                        display: 'flex'
                    }}
                >
                    <SectionCard title={about.title} sx={{ width: '100%' }}>
                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(0, 71, 110, 0.82)',
                                lineHeight: 1.85,
                                mb: 2
                            }}
                        >
                            {about.body1}
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(0, 71, 110, 0.82)',
                                lineHeight: 1.85
                            }}
                        >
                            {about.body2}
                        </Typography>
                    </SectionCard>
                </Box>
            </Box>

            <Box sx={splitRowSx}>
                <Box
                    sx={{
                        width: { xs: '100%', md: '58%' },
                        display: 'flex',
                        order: { xs: 2, md: 1 }
                    }}
                >
                    <SectionCard title={about.therapistCardTitle} sx={{ width: '100%' }}>
                        <Typography
                            variant="h5"
                            sx={{ color: '#00476e', fontWeight: 700, mb: 1 }}
                        >
                            {about.therapistName}
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(0, 71, 110, 0.78)',
                                lineHeight: 1.85
                            }}
                        >
                            {about.therapistBio}
                        </Typography>
                    </SectionCard>
                </Box>

                <Box
                    sx={{
                        width: { xs: '100%', md: '42%' },
                        flexShrink: 0,
                        order: { xs: 1, md: 2 }
                    }}
                >
                    <Box sx={{ ...imageCardSx, height: '100%' }}>
                        <Box
                            component="img"
                            src="/img/therapist_cropped.webp"
                            alt="Cozy speech therapy office"
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: 'block'
                            }}
                        />
                    </Box>
                </Box>
            </Box>

            <Box sx={splitRowSx}>
                <Box
                    sx={{
                        width: { xs: '100%', md: '42%' },
                        flexShrink: 0
                    }}
                >
                    <Box sx={{ ...imageCardSx, height: '100%' }}>
                        <Box
                            component="img"
                            src="/img/therapist_and_child_1.webp"
                            alt="Warm speech therapy session"
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: 'block'
                            }}
                        />
                    </Box>
                </Box>

                <Box
                    sx={{
                        width: { xs: '100%', md: '58%' },
                        display: 'flex'
                    }}
                >
                    <SectionCard
                        title={about.therapistCertificationsCardTitle}
                        sx={{ width: '100%' }}
                    >
                        {about.therapistCertifications?.length > 0 && (
                            <Box component="ul" sx={{ pl: 3, m: 0 }}>
                                {about.therapistCertifications.map((certification, index) => (
                                    <Box component="li" key={index} sx={{ mb: 1 }}>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: 'rgba(0, 71, 110, 0.78)',
                                                lineHeight: 1.8
                                            }}
                                        >
                                            {certification}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        )}
                    </SectionCard>
                </Box>
            </Box>
        </Container>
    );
};

export default About;